import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, Card, CardTitle, Input } from "@electro-planner/ui";
import { authClient } from "../lib/auth.ts";

type Status =
  | { kind: "idle" }
  | { kind: "pending" }
  | { kind: "ok"; message: string }
  | { kind: "err"; message: string };

export function LoginRoute() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>({ kind: "idle" });

  const { data: session } = authClient.useSession();
  if (session?.user) {
    navigate("/organizations", { replace: true });
  }

  async function handlePasskey() {
    setStatus({ kind: "pending" });
    try {
      const res = await authClient.signIn.passkey();
      if (res?.error) {
        setStatus({ kind: "err", message: res.error.message ?? "Passkey misslyckades." });
      } else {
        navigate("/organizations", { replace: true });
      }
    } catch (err) {
      setStatus({ kind: "err", message: (err as Error).message });
    }
  }

  async function handleMagicLink() {
    setStatus({ kind: "pending" });
    try {
      const res = await authClient.signIn.magicLink({
        email,
        callbackURL: "/organizations",
      });
      if (res?.error) {
        setStatus({ kind: "err", message: res.error.message ?? "Magic-link misslyckades." });
      } else {
        setStatus({
          kind: "ok",
          message: "Magic link skickad. Kolla din inkorg (eller server-konsolen under dev).",
        });
      }
    } catch (err) {
      setStatus({ kind: "err", message: (err as Error).message });
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center p-8">
      <Card className="w-full max-w-sm">
        <CardTitle>Logga in</CardTitle>
        <p className="mb-4 text-sm text-[var(--color-muted)]">
          Passkey föredras. Om du inte har en passkey än — be om en magic link.
        </p>
        <div className="flex flex-col gap-3">
          <Button onClick={handlePasskey} disabled={status.kind === "pending"}>
            Logga in med passkey
          </Button>
          <div className="my-2 text-center text-xs uppercase text-[var(--color-muted)]">
            eller
          </div>
          <Input
            type="email"
            placeholder="din@epost.se"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <Button
            variant="secondary"
            onClick={handleMagicLink}
            disabled={status.kind === "pending" || !email}
          >
            Skicka magic link
          </Button>
          {status.kind === "ok" && (
            <p className="text-sm text-[var(--color-success)]">{status.message}</p>
          )}
          {status.kind === "err" && (
            <p className="text-sm text-[var(--color-danger)]">{status.message}</p>
          )}
        </div>
      </Card>
    </div>
  );
}
